// Referral Outcome Report (Physiotherapy)
export const HrManager = "HrManager";
export const EmployeeSeen = "EmployeeSeen";
export const EmployeeAddress = "EmployeeAddress";
export const Dob = "Dob";
export const EmployerAndDivision = "EmployerAndDivision";
export const JobTitle = "JobTitle";
export const DateOfConsultation = "DateOfConsultation";
export const ConsultationType = "ConsultationType";
export const EmployeeId = "EmployeeId";
export const ReportType = "ReportType";

// Summary
export const WorkClassification = "WorkClassification";
export const FirstDayOfAbsence = "FirstDayOfAbsence";
export const AdvisedTargetReturnToWorkDate = "AdvisedTargetReturnToWorkDate";
export const FitnessOutcome = "FitnessOutcome";
export const Adjustments = "Adjustments";
export const AdjustmentsRecommended = "AdjustmentsRecommended";
export const AdjustmentsEndDate = "AdjustmentsEndDate";
export const PhasedReturnToWorkRecommended = "PhasedReturnToWorkRecommended";
export const DurationOfPhasedReturn = "DurationOfPhasedReturn";
export const OnwardReferral = "OnwardReferral";
export const GpSpecialistReportRequested = "GpSpecialistReportRequested";
export const EqualityActLikelyToApply = "EqualityActLikelyToApply";
export const JustificationForEqualityActOpinion = "JustificationForEqualityActOpinion";
export const ReasonForReferral = "ReasonForReferral";
export const SelfManagementWithAdviceAndExercises = "SelfManagementWithAdviceAndExercises";

// Background and Reason for Referral
export const BackgroundReasonsForReferral = "BackgroundReasonsForReferral";

// Assessment and Opinions
export const AssessmentAndOpinions = "AssessmentAndOpinions";

// Information/Answers
export const RecommendationsAndSummary = "RecommendationsAndSummary";
export const AdditionalInfo = "AdditionalInfo";

// Physiotherapy Specific Recommendations
export const StandingAndWalkingRecommendations = "StandingAndWalkingRecommendations";
export const StandingAndWalkingTimeFrame = "StandingAndWalkingTimeFrame";
export const SquattingKneelingSteppingRecommendations = "SquattingKneelingSteppingRecommendations";
export const SquattingKneelingSteppingTimeFrame = "SquattingKneelingSteppingTimeFrame";
export const GripStrengthWorkingAtShoulderHeightOrAboveHeadRecommendations = "GripStrengthWorkingAtShoulderHeightOrAboveHeadRecommendations";
export const GripStrengthWorkingAtShoulderHeightOrAboveHeadTimeFrame = "GripStrengthWorkingAtShoulderHeightOrAboveHeadTimeFrame";
export const LiftingCarryingRecommendations = "LiftingCarryingRecommendations";
export const LiftingCarryingTimeFrame = "LiftingCarryingTimeFrame";
export const PushingPullingRecommendations = "PushingPullingRecommendations";
export const PushingPullingTimeFrame = "PushingPullingTimeFrame";
export const SeatedActivitiesDeskWorkAndDrivingRecommendations = "SeatedActivitiesDeskWorkAndDrivingRecommendations";
export const SeatedActivitiesDeskWorkAndDrivingTimeFrame = "SeatedActivitiesDeskWorkAndDrivingTimeFrame";
export const PMVA_CAndRRecommendations = "PMVA_CAndRRecommendations";
export const PMVA_CAndRTimeFrame = "PMVA_CAndRTimeFrame";
export const PatientHandlingRecommendations = "PatientHandlingRecommendations";
export const PatientHandlingTimeFrame = "PatientHandlingTimeFrame";

// Discharge after Treatment Information
export const NumberOfSessionsIncludingInitialAssessment = "NumberOfSessionsIncludingInitialAssessment";
export const ManagementDetails = "ManagementDetails";
export const Outcome = "Outcome";
export const WorkStatusAtInitialAssessment = "WorkStatusAtInitialAssessment";
export const WorkStatusAtDischarge = "WorkStatusAtDischarge";
export const QuestionnaireScoresAtInitialAssessment = "QuestionnaireScoresAtInitialAssessment";
export const QuestionnaireScoresAtDischarge = "QuestionnaireScoresAtDischarge";

// Report Details
export const ReportDate = "ReportDate";
export const CliniciansId = "CliniciansId";
export const CliniciansName = "CliniciansName";
export const CliniciansQualification = "CliniciansQualification";
export const CliniciansEmail = "CliniciansEmail";
